<template>
  <div :id="accordionId" class="accordion mb-7" :class="{'mx-3' : !customMode}">
    <div class="accordion-item box shadow-lg px-4 py-1">
      <div class="accordion-header relative" :id="`accordion-content-${accordionId}`">
        <div
          class="accordion-button box shadow-none cursor-pointer flex justify-between items-center"
          data-bs-toggle="collapse"
          type="button"
          :data-bs-target="`#accordion-collapse-${accordionId}`"
          :aria-expanded="isOpen"
          :aria-controls="`accordion-collapse-${accordionId}`"
          :class="{'collapsed':!isOpen}"
        >
          <slot name="header-content">
            <div class="inline-block bg-theme-39 py-2 px-3 rounded-md">
              {{ headerText }}
            </div>
          </slot>
          <div class="flex flex-row items-center">
            <p :class="{ 'text-theme-42': have, 'text-theme-36': !have }" v-if="iconText">
              {{ have ? "มี" : "ไม่มี" }}
            </p>
            <ChevronDownIcon class="h-4 w-4" v-if="showIcon"/>
          </div>
        </div>
        <slot name="outside-header-button">

        </slot>
      </div>
      <div
        :id="`accordion-collapse-${accordionId}`"
        class="accordion-collapse collapse flex"
        :aria-labelledby="`accordion-content-${accordionId}`"
        :data-bs-parent="`#${accordionId}`"
        :class="{'show': isOpen}"
      >
        <div
          class="accordion-body text-gray-700 dark:text-gray-600 leading-relaxed w-full"
        >
          <slot name="body-content">
            <div
              class="flex justify-between items-center flex-wrap"
              v-for="item in detail"
              :key="item.title"
            >
              <p>{{ item.title }}</p>
              <div>
                <span>{{ item.value }}</span>
                <span class="ml-2">{{ item.unit }}</span>
              </div>
            </div>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const props = defineProps({
  headerText: {
    type: String,
    default: "ที่ดิน",
  },
  detail: {
    type: Array,
    default: () => [
      { title: "อาศัย", value: 2, unit: "ไร่" },
      { title: "ทำกิน", value: 2, unit: "ไร่" },
      { title: "มรดก", value: 2, unit: "ไร่" },
    ],
  },
  have: { type: Boolean, default: true },
  accordionId: {type:String},
  isOpen: {
    type: Boolean,
    default: false
  },
  iconText:{
    type: Boolean,
    default: true
  },
  customMode:{
    type: Boolean,
    default: false
  },
  showIcon:{
    type: Boolean,
    default: true
  }
});

const open = ref(false);
</script>
<style lang="scss">
.accordion-button .feather-chevron-down{
  transition: transform .1s ease;
}
.accordion-button[aria-expanded="true"] .feather-chevron-down {
  transform: rotate(180deg);
  transition: transform .1s ease;
}
</style>
